import React, { useContext, useEffect, useRef, useState } from 'react';
import eyeImg from '../assets/images/eye-1.svg';
import trashImg from '../assets/images/trash-2.svg';
import userImg from '../assets/images/user-8.svg';
import buildingImg from '../assets/images/building-2-3.svg';
import { AccountContext } from '../context';
import { useDebounce } from '../helpers/useDebounce';
import { getTenant } from '../../../hooks';

const Header = () => {
  const { userMetaData, userData, handleImgUploadToAPI } =
    useContext(AccountContext);

  const [isProfileImageSet, setIsProfileImageSet] = useState(false);
  const [uploadedImgUrl, setUploadedImgUrl] = useState('');
  const [currentTenant, setCurrentTenant] = useState("")

  const uploadInputElement = useRef<HTMLInputElement>();

  const MAX_FILE_SIZE = 1024*1024

  const handleImgPreviewClick = () => {
    window.open(uploadedImgUrl, '_blank');
  };

  const handleImgUploadChange = async (e) => {
    if (!e) {
      return;
    }
    const file = e?.target?.files[0];
    if(file.size >= MAX_FILE_SIZE){
      alert("Profile pic must not exceed 1Mb")
      return
    }
    const blobImg = URL.createObjectURL(file);
    setUploadedImgUrl(blobImg);
    setIsProfileImageSet(true);

    /*const formdata = new FormData();
    formdata.append("file", file)*/
    uploadInputElement.current.value = '';
    //const base64 = await convertToBinary(e);




    const formdata = new FormData();
// Assuming `fileInput` is a reference to an <input type="file"> in your HTML
    formdata.append("file", file);
    handleImgUploadToAPI(formdata);

    /*const requestOptions = {
      method: "POST",
      //headers: myHeaders,
      body: formdata,
      redirect: "follow",
      credentials: 'include' // This line is added to include credentials like cookies
    };*/



  };

  const handleImgRemove = () => {
    setIsProfileImageSet(false);
  };

  const handleImgUploadClick = () => {
    if (!!isProfileImageSet) {
      return;
    }
    uploadInputElement.current.click();
  };

  useDebounce(
    () => {
      setIsProfileImageSet(!!userMetaData?.public_metadata?.profile_image);
      if(typeof userMetaData?.public_metadata?.profile_image === "string"){
        setUploadedImgUrl(userMetaData?.public_metadata?.profile_image);
      }else{
        setUploadedImgUrl(userMetaData?.public_metadata?.profile_image?.image_url_full);
      }
    },
    300,
    [userMetaData?.public_metadata?.profile_image]
  );

  useEffect(()=>{
    setCurrentTenant(getTenant())
  }, [])


  return (
    <div className="w-layout-vflex-account-ui account-user-details-content-block">
      <div
        onClick={() => handleImgUploadClick()}
        className={`w-layout-hflex-account-ui mentor-image-uploader ${
          !isProfileImageSet ? 'empty' : ''
        }`}
      >
        <input
          ref={uploadInputElement}
          onChange={!!isProfileImageSet ? () => {} : handleImgUploadChange}
          type="file"
          className="input-mentor-image-upload"
          accept="image/*"
        />
        <div
          className={`w-layout-hflex-account-ui upload-text-box ${
            !!isProfileImageSet ? 'hidden' : ''
          }`}
        >
          <div className="text-block-52">+ Upload</div>
        </div>
        <div
          className={`w-layout-hflex-account-ui upload-img-box ${
            !!isProfileImageSet ? '' : 'hidden'
          }`}
          style={{
            backgroundImage: `url(${uploadedImgUrl})`,
          }}
        >
          <div className="w-layout-hflex-account-ui upload-action-btn-container">
            <img
              onClick={() => handleImgPreviewClick()}
              src={eyeImg}
              loading="lazy"
              alt=""
              className="upload-action-btn-icon view"
            />
            <img
              onClick={() => handleImgRemove()}
              src={trashImg}
              loading="lazy"
              alt=""
              className="upload-action-btn-icon remove"
            />
          </div>
        </div>
      </div>
      <div className="w-layout-vflex-account-ui account-user-specific-details-block">
        <h5 className="account-userfullname">{userMetaData?.name || ''}</h5>
        <div className="w-layout-hflex-account-ui account-info-pill-block">
          <div className="w-layout-hflex-account-ui info-pill-block">
            <img
              src={userImg}
              loading="lazy"
              alt=""
              className="info-pill-icon"
            />
            <div className="info-pill-label">Student</div>
          </div>
          {
            currentTenant !== "" && <div className="w-layout-hflex-account-ui info-pill-block filled">
              <img
                src={buildingImg}
                loading="lazy"
                alt=""
                className="info-pill-icon"
              />
              <div className="info-pill-label white first-letter-capitalize">{currentTenant}</div>
            </div>
          }
        </div>
      </div>
    </div>
  );
};

export default Header;
